<template>
  <div class="ic-form__k-04">
    <FormWrapper :validator="$v.form">
      <IcFormContactEmail v-model="form.email" />
      <icFormContactName v-model="form.name" />
      <IcFormRowWrapper
        id="url"
        name="url"
        :labelWidth="4"
        :controlWidth="8"
        :showSingleError="true"
      >
        <IcCheckbox v-model="form.invoice" :val="1" id="invoice">{{$t('label_want_invoice')}}</IcCheckbox>
      </IcFormRowWrapper>

      <IcFormContactCompany v-model="form.company" v-if="form.invoice == 1" />
      <IcFormContactTicket v-model="form.ticket" v-if="form.invoice == 1" />
      <h3 v-if="form.invoice == 1">Wiadomość</h3>
      <IcFormContactMessage v-model="form.message" />
      <IcFormContactFiles v-model="form.files" />
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"
              :label="$t('label_agreement_checkbox')" content="form_agreement_k05">
      </IcFormAgreements>

      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormContactK01 from "./k_01";
import IcFormContactCompany from "./Base/Company";
import IcFormContactTicket from "./Base/Ticket";
import IcFormContactName from "./Base/Name";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox";
import validations from "./Validation/k_05.js";

import { Name } from "./Model/Name";
import { Company } from "./Model/Company";
import { Ticket } from "./Model/Ticket";

export default {
  extends: IcFormContactK01,
  name: "IcFormContactK05",
  validations,
  data() {
    return {
      form: {
        type: "k05",
        invoice: 0,
        
        company: new Company(),
        name: new Name(),
        ticket: new Ticket()
      }
    };
  },
  watch: {
    "form.name": {
      deep: true,
      handler: function(newValue, oldValue) {
        this.form.company.company = [
          newValue.firstName,
          newValue.lastName
        ].join(" ");
      }
    }
  },
  components: {
    IcFormContactCompany,
    IcFormContactTicket,
    IcFormContactName,
    IcCheckbox
  }
};
</script>

<style>
</style>
